module.exports = {"441781001":"春城街道","441781002":"河西街道","441781101":"河朗镇","441781102":"松柏镇","441781103":"石望镇","441781105":"春湾镇","441781106":"合水镇","441781107":"陂面镇","441781108":"圭岗镇","441781109":"永宁镇","441781110":"马水镇","441781111":"岗美镇","441781112":"河口镇","441781113":"潭水镇","441781114":"三甲镇","441781116":"双窖镇","441781117":"八甲镇","441781402":"三叶农场","441781403":"石录矿区","441781404":"花滩林场","441781405":"东湖林场","441781406":"河尾山林场","441781407":"南山矿","441781408":"阳春监狱","441781410":"硫铁矿"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441781.json
// module id = 2045
// module chunks = 0